( function ( $ ) {
    'use strict';
    let $document          = $( document ),
        $window            = $( window ),
        $body              = $( 'body' ),
        $clone_sticky_menu = $( '.main-menu.armania-clone-sticky-menu > *' ),
        $back_to_top       = $( '.backtotop' ),
        $mbl_menu_wraper   = $( '.armania-menu-clone-wrap' ),
        $clone_mobile_menu = $( '.armania-clone-mobile-menu' );
  
  
    if ( !$mbl_menu_wraper.length && $clone_mobile_menu.length > 0 ) {
        let $tpl_mbl_menu = '<div class="armania-menu-clone-wrap">';
        $tpl_mbl_menu += '<div class="armania-menu-panels-actions-wrap">';
        $tpl_mbl_menu += '<span class="armania-menu-current-panel-title">MAIN MENU</span>';
        $tpl_mbl_menu += '<a class="armania-menu-close-btn armania-menu-close-panels" href="#">x</a>';
        $tpl_mbl_menu += '</div>';
        $tpl_mbl_menu += '<div class="armania-menu-panels"></div>';
        $tpl_mbl_menu += '</div>';
        $body.prepend( $tpl_mbl_menu );
        $mbl_menu_wraper = $( '.armania-menu-clone-wrap' )
    }
  
    /*==========================================================================
     CLONE MOBILE MENU
     ===========================================================================*/
    $.fn.armania_menuclone_all_menus = function () {
        var _this = $( this );
        _this.on( 'armania_menuclone_all_menus', function () {
            var i = 0;
            if ( !$( '#armania-menu-panel-main' ).length ) {
                $mbl_menu_wraper.find( '.armania-menu-panels' ).append( '<div id="armania-menu-panel-main" class="armania-menu-panel armania-menu-panel-main"><ul class="depth-01"></ul></div>' );
            }
            $( this ).each( function () {
                var $this              = $( this ),
                    thisMenu           = $this,
                    this_menu_id       = thisMenu.attr( 'id' ),
                    this_menu_clone_id = 'armania-menu-clone-' + this_menu_id;
                if ( !$( '#' + this_menu_clone_id ).length ) {
                    var thisClone = $this.clone( true ); // Clone Wrap
                    thisClone.find( '.menu-item' ).addClass( 'clone-menu-item' );
                    thisClone.find( '[id]' ).each( function () {
                        /*Change all tab links with href = this id*/
                        thisClone.find( '.armania-menu-tabs .tabs-link a[href="#' + $( this ).attr( 'id' ) + '"]' ).attr( 'href', '#' + armania_menu_prefix_added( $( this ).attr( 'id' ), 'armania-menu-clone-' ) );
                        $( this ).attr( 'id', armania_menu_prefix_added( $( this ).attr( 'id' ), 'armania-menu-clone-' ) );
                    } );
                    thisClone.find( '.armania-menu-menu' ).addClass( 'armania-menu-menu-clone' );
  
                    /*Create main panel if not exists*/
                    var thisMainPanel = $( '.armania-menu-clone-wrap .armania-menu-panels #armania-menu-panel-main ul' );
                    thisMainPanel.append( thisClone.html() );
                    armania_menu_insert_children_panels_html_by_elem( thisMainPanel, i );
                }
            } );
        } ).trigger( 'armania_menuclone_all_menus' );
    };
  
    function armania_menu_insert_children_panels_html_by_elem ( $elem, i ) {
        if ( $elem.find( '.menu-item-has-children' ).length ) {
            $elem.find( '.menu-item-has-children' ).each( function () {
                var thisChildItem = $( this );
                armania_menu_insert_children_panels_html_by_elem( thisChildItem, i );
                var next_nav_target = 'armania-menu-panel-' + i;
  
                /*Make sure there is no duplicate panel id*/
                while ( $( '#' + next_nav_target ).length ) {
                    i++;
                    next_nav_target = 'armania-menu-panel-' + i;
                }
  
                /*Insert Next Nav*/
                thisChildItem.prepend( '<a class="armania-menu-next-panel" href="#' + next_nav_target + '" data-target="#' + next_nav_target + '"></a>' );
  
                /*Get sub menu html*/
                var sub_menu_html = $( '<div>' ).append( thisChildItem.find( '> .sub-menu' ).clone() ).html();
                thisChildItem.find( '> .sub-menu' ).remove();
  
                $( '.armania-menu-clone-wrap .armania-menu-panels' ).append( '<div id="' + next_nav_target + '" class="armania-menu-panel armania-menu-sub-panel armania-menu-hidden">' + sub_menu_html + '</div>' );
            } );
        }
    }
  
    function armania_menu_prefix_added ( str, prefix ) {
        return prefix + str;
    }
  
    /*BOX MOBILE MENU*/
    $document.on( 'click', '.menu-toggle', function ( e ) {
        e.preventDefault();
        $( '.armania-menu-clone-wrap' ).addClass( 'open' );
    } );
    /*Close box menu*/
    $document.on( 'click', '.armania-menu-clone-wrap .armania-menu-close-panels', function ( e ) {
        e.preventDefault();
        $( '.armania-menu-clone-wrap' ).removeClass( 'open' );
    } );
    $document.on( 'click', 'a.backtotop', function ( e ) {
        e.preventDefault();
        $( 'html, body' ).animate( { scrollTop : 0 }, 800 );
    } );
    window.addEventListener( 'load',
        function ( ev ) {
            $clone_mobile_menu.armania_menuclone_all_menus();
        }, false );
  
    $( document ).on( 'click', '.days-sticky-banner__closer', function ( event ) {
        event.preventDefault();
        $( this ).closest( '.days-sticky-banner' ).remove();
    } );
    const readyFn = function ( jquery ) {
        setTimeout( () => $( '.days-sticky-banner' ).css( 'transform', ' scale(1)' ), 800 );
    }
  
    $( window ).on( "load", readyFn );
    $( function () {
        $( '.item_slick_slider' ).slick( {
            infinite       : true,
            slidesToShow   : 5,
            slidesToScroll : 1,
            autoplay       : false,
            autoplaySpeed  : 4000,
            prevArrow      : '<button type="button" class="slider-prev"><span class="dli-chevron-left"></span></button>',
            nextArrow      : '<button type="button" class="slider-next"><span class="dli-chevron-right"></span></button>', 
            responsive     : [
                {
                    breakpoint : 1199,
                    settings   : {
                        slidesToShow : 4
                    }
                },
                {
                    breakpoint : 991,
                    settings   : {
                        slidesToShow : 3
                    }
                },
                {
                    breakpoint : 767,
                    settings   : {
                        slidesToShow : 2
                    }
                }
            ]
        } );
    } );
    $(function(){
        $('.collection_image_carousel').slick({
            infinite       : true,
            slidesToShow   : 3,
            slidesToScroll : 1,
            autoplay       : false,
            autoplaySpeed  : 4000,
            prevArrow      : '<button type="button" class="slider-prev"><span class="dli-chevron-left"></span></button>',
            nextArrow      : '<button type="button" class="slider-next"><span class="dli-chevron-right"></span></button>',  
            responsive     : [
                {
                    breakpoint : 1199,
                    settings   : {
                        slidesToShow : 3
                    }
                },
                {
                    breakpoint : 991,
                    settings   : {
                        slidesToShow : 2
                    }
                },
                {
                    breakpoint : 767,
                    settings   : {
                        slidesToShow : 2
                    }
                }
            ]
        });
				
    });
		jQuery(document).ready(function($) {
			var element_position = $('.related-products').offset().top;
			$(window).on('scroll', function() {
				$('.related-products-slider').slick({
					infinite       : false,
					slidesToShow   : 5,
					slidesToScroll : 1,
					autoplay       : false,
					autoplaySpeed  : 4000,
					prevArrow      : '<button type="button" class="slider-prev"><span class="dli-chevron-left"></span></button>',
					nextArrow      : '<button type="button" class="slider-next"><span class="dli-chevron-right"></span></button>', 
					responsive     : [
							{
									breakpoint : 1199,
									settings   : {
											slidesToShow : 4
									}
							},
							{
									breakpoint : 991,
									settings   : {
											slidesToShow : 3
									}
							},
							{
									breakpoint : 767,
									settings   : {
											slidesToShow : 2
									}
							}
					]
				});
			});
		});    

    $( '.js_slider' ).slick( {
        infinite       : false,
        slidesToShow   : 1,
        slidesToScroll : 1,
        autoplay       : true,
        autoplaySpeed  : 4000,
        arrows         : false,
        dots           : false,
    } );
  } )( window.jQuery );